module.exports = {
      id: "gn-reach-icon-usage",
      viewBox: "0 0 159 50",
      url: __webpack_public_path__ + "svg-sprite-afa9d3605aa6d2fee8793cc86cfa3445.svg#gn-reach-icon",
      toString: function () {
        return this.url;
      }
    }